import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../core/services/authentication.service';
import { IgmsAlertData } from '../shared/dialogs/gms-alert/gms-alert.component';
import { IChangeWordp, IChangeWordpData } from '../shared/interfaces/gmsdata.interface';
import { GmsdialogService } from '../shared/services/gmsdialog.service';
import { ConfirmedValidator } from '../shared/validators/confirmpassword.validator';

@Component({
    selector: 'app-changepassword',
    templateUrl: './changepassword.component.html',
    styleUrls: ['./changepassword.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangepasswordComponent implements OnInit {
  public newPasswordForm: UntypedFormGroup;
  constructor(private formBuilder: UntypedFormBuilder, private authSer: AuthenticationService, private gmsAlertSer: GmsdialogService,
    private router: Router) {}

  ngOnInit (): void {
    const sessionValue = this.authSer.sessionValue;
    if (sessionValue == "" || sessionValue === null || sessionValue === undefined) {
      const data: IgmsAlertData = {
        message: 'Please login to access the page',
        buttonText: 'CLOSE',
        title: ""
      };
      this.gmsAlertSer.showAlert(data, "330px");
      this.router.navigate(['/login']);

    } else {
      this.newPasswordForm = this.formBuilder.group({
        // oldPassword: ['', [Validators.required, Validators.minLength(3)]],
        newPassword: ['', [Validators.required, Validators.minLength(3)]],
        verifyPassword: ['', [Validators.required]],
      }, {
        validator: ConfirmedValidator('newPassword', 'verifyPassword')
      });
    }
  }
  onCancel () {
    this.router.navigate(['/welcome']);
  }

  get formValues () { return this.newPasswordForm.controls; }
  onSubmit (reqPassworForm: IChangeWordp) {
    //const md5 = new Md5();
    //  var md5Password = md5.appendStr(reqPassworForm.oldPassword).end();
    // const salt = bcrypt.genSaltSync(10);
    // var bcriptPass = bcrypt.hashSync(reqPassworForm.newPassword, salt);
    //var changePassData: IChangeWordpData = { old_password: md5Password.toString(), new_password: bcriptPass };
    var changePassData: IChangeWordpData = { new_password: reqPassworForm.newPassword };
    if (this.newPasswordForm.valid) {
      this.authSer.changePassword(changePassData).subscribe((response: any) => {
        // data: "Successfull"
        if (response.data.status == true) {
          const data: IgmsAlertData = {
            message: 'Password changed successfully.',
            buttonText: 'CLOSE',
            title: ""
          };
          this.gmsAlertSer.showAlert(data, "330px");
          this.router.navigate(['/login']);
        }
        // if (response.data == "Successfull") {
        //   const data: IgmsAlertData = {
        //     message: 'Password changed successfully.',
        //     buttonText: 'CLOSE',
        //     title: ""
        //   };
        //   this.gmsAlertSer.showAlert(data, "330px");
        //   this.router.navigate(['/login']);
        //   //this.authSer.sessionValue = response.data.session_key
        //   /* if (this.authSer.sessionValue) {
        //      if (this.authSer.redirectUrl) {
        //        this.router.navigateByUrl(this.authSer.redirectUrl)
        //      } else {
        //        this.router.navigate(['/welcome']);
        //      }
        //    }*/
        // }
      });
    }
  }
}
